<template>
  <div class="information-box">
    <div class="information-ul">
      <!-- 循环渲染每个课程 -->
      <div class="information-li" v-for="(item, index) in information" :key="index" @click="gotonewsDetails(item)">
        <div class="information-img">
          <img :src="item.image.url" v-if="item.image && item.image.url != undefined" />
          <img v-else src="@/assets/images/logo-img.png" alt="">
        </div>
        <div class="information-text">
          <div class="information-top">
            <div class="information-h">{{ item.title }}</div>
            <div class="information-p">{{ item.introduction }}</div>
          </div>
          <div class="information-bottom">
            <div class="information-left"></div>
            <div class="information-right">
              {{ item.createTimeFormat }}
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[6, 10, 20, 30]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
    </el-pagination>
  </div>
</template>

<script>
import { getPageDetails } from '@/api/home'
export default {
  name: "information",
  props: {
    information: {
      type: Array,
      required: true // 父组件传递课程列表
    },
    page: {
      type: Object,
      default: {}
    }
  },
  methods: {
    gotonewsDetails(value) {
      if(value.isForward) {
        this.getPageDetails(value.id)
        window.open(value.h5Url, '_blank')
      }else {
        this.$router.push({ path: `/NewsDetails/${value.id}` }); // 动态路由传递课程 id
      }
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails(id) {
      getPageDetails({
        id: id
      }).then(res => {
      })
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.information-ul {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  gap: 24px;

  .information-li:hover {
    box-shadow: 0px 14px 22px 0px rgba(0, 0, 0, 0.08);
    border-bottom: 5px solid rgba(191, 16, 22, 1);

    .information-left {
      background: url("~@/assets/images/goto2.png") no-repeat center center rgba(156, 29, 34, 1) !important;
      background-size: 19px 19px;
    }

    .information-h {
      color: rgba(164, 18, 24, 1) !important;
    }
  }

  .information-li {
    width: calc(33.3% - 16px);
    background: #fff;
    margin-top: 30px;
    padding: 16px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 5px solid transparent;

    .information-img {
      width: 100%;
      height: 232px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .information-top{
      height: 153px;
    }
    .information-text {
      margin-top: 24px;

      .information-h {
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
        line-height: 26px;
        font-weight: bold;
        text-align: left;
        display: -webkit-box;             /* 必须设置，用于多行溢出 */
        -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
        -webkit-line-clamp: 3;            /* 限制显示的行数，例如显示 3 行 */
        overflow: hidden;                 /* 隐藏超出的内容 */
      }

      .information-p {
        color: rgba(98, 99, 101, 1);
        font-size: 14px;
        line-height: 25px;
        height: 75px;
        text-align: left;
        margin-top: 8px;
        display: -webkit-box;             /* 必须设置，用于多行溢出 */
        -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
        -webkit-line-clamp: 3;            /* 限制显示的行数，例如显示 3 行 */
        overflow: hidden;                 /* 隐藏超出的内容 */
      }

      .information-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        .information-left {
          border: 1px solid rgba(209, 209, 209, 1);
          width: 44px;
          height: 44px;
          background: url("~@/assets/images/goto.png") no-repeat center center;
          background-size: 19px 19px;
        }

        .information-right {
          color: rgba(98, 99, 101, 1);
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/index.vue